// extracted by mini-css-extract-plugin
export default {"activityContainer":"Activity_activityContainer__KfQ69","cardList":"Activity_cardList__zaxze"};